import React from 'react'
import MapDisplay from '.'
import Footer from './Footer'
import './style.css'

export default function WorldMap({ width, progress, setProgress, endDate, started }) {
  return (
    <div className='map'>
      <MapDisplay
        width={width}
        progress={progress}
        maxWidth={400}
        aspect={0.5}
        setProgress={setProgress}
        imageUrl='https://ta-interaktiv.s3.eu-central-1.amazonaws.com/klima-dashboard/copernicus/images/'
        overlays={['landmass2.svg', 'landmass.svg']}
        endDate={endDate}
        placeholderImage='world-placeholder.jpg'
        started={started}
      />
      <Footer />
    </div>
  )
}
